import { paymentType } from '../../assets/helpers/options';

// Pago inicial 0 con Cashea: no se registran pagos tradicionales y el
// total de la transacción pasa a cuentas por cobrar (CxC); el backend
// marca el pago como comprobado automáticamente.
export const useCasheaPayment = ({ watch, enabled = true }) => {
  const isZeroInitialCashea =
    enabled &&
    watch('paymentType') === paymentType?.CASHEA &&
    parseFloat(watch('initial')) === 0;

  // La referencia de Cashea se eleva a la raíz del payload porque
  // no existe ningún objeto de pago que pueda transportarla
  const appendCasheaZeroInitial = (formData) => {
    formData.append('referenceCashea', watch('referenceCashea'));
  };

  return { isZeroInitialCashea, appendCasheaZeroInitial };
};
